webpackJsonp([1],{

/***/ "/nQJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0ocF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4lmW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6k6n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7L41":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JVnm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KsKM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: 'app'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8d0d9a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('simulator-modal')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("ZYS2")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HelloWorld.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HelloWorld = ({
  name: 'HelloWorld',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4241e014","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HelloWorld.vue
var HelloWorld_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0,false,false),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1,false,false)])}
var HelloWorld_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://chat.vuejs.org","target":"_blank"}},[_vm._v("Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank"}},[_vm._v("awesome-vue")])])])}]
var HelloWorld_esExports = { render: HelloWorld_render, staticRenderFns: HelloWorld_staticRenderFns }
/* harmony default export */ var components_HelloWorld = (HelloWorld_esExports);
// CONCATENATED MODULE: ./src/components/HelloWorld.vue
function HelloWorld_injectStyle (ssrContext) {
  __webpack_require__("gu2T")
}
var HelloWorld_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var HelloWorld___vue_template_functional__ = false
/* styles */
var HelloWorld___vue_styles__ = HelloWorld_injectStyle
/* scopeId */
var HelloWorld___vue_scopeId__ = "data-v-4241e014"
/* moduleIdentifier (server only) */
var HelloWorld___vue_module_identifier__ = null
var HelloWorld_Component = HelloWorld_normalizeComponent(
  HelloWorld,
  components_HelloWorld,
  HelloWorld___vue_template_functional__,
  HelloWorld___vue_styles__,
  HelloWorld___vue_scopeId__,
  HelloWorld___vue_module_identifier__
)

/* harmony default export */ var src_components_HelloWorld = (HelloWorld_Component.exports);

// CONCATENATED MODULE: ./src/Store.js
/**
 * simple store
 */

/* harmony default export */ var Store = ({
  state: {
    currentMusicName: "",
    currentProjectName: "",
    currentMusic: null,
    currentProject: null
  },
  setMusicAction: function setMusicAction(newMusicSrc, newMusicName) {
    this.state.currentMusic = newMusicSrc;
    this.state.currentMusicName = newMusicName;
  },
  setProjectAction: function setProjectAction(newFileObj, projectName) {
    this.state.currentProject = newFileObj;
    this.state.currentProjectName = projectName;
  }
});
// CONCATENATED MODULE: ./src/Const.js
var SITE_NAME = "PxB Playground";
var SITE_VER = "act.0";
var PROJECT_EXT = "pxbp";
var USER_DATA_STORE_KEY = "pxbp_userData_v1";
// EXTERNAL MODULE: ./node_modules/sweetalert/dist/sweetalert.min.js
var sweetalert_min = __webpack_require__("thjQ");
var sweetalert_min_default = /*#__PURE__*/__webpack_require__.n(sweetalert_min);

// EXTERNAL MODULE: ./static/sample/sample-music-list.json
var sample_music_list = __webpack_require__("cPLG");
var sample_music_list_default = /*#__PURE__*/__webpack_require__.n(sample_music_list);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/SwitchButton.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var SwitchButton = ({
  name: 'switchButton',
  props: {
    label: { type: String, default: "ON" },
    sleepLabel: { type: String, default: "OFF" },
    width: { type: Number, default: 80 },
    classes: String, // temp
    isActive: { type: Boolean, default: true }
  },
  computed: {
    classObject: function classObject() {
      var obj = {
        'switchButton': true,
        'active': this.isActive
      };
      var styleClass = this.classes ? this.classes : 'switchButton_default-style';
      obj[styleClass] = true;
      return obj;
    },
    styleObject: function styleObject() {
      return {
        'width': this.width + "px"
      };
    }
  },

  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b5964ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/SwitchButton.vue
var SwitchButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject,style:(_vm.styleObject),on:{"click":_vm.onClick}},[_vm._v(_vm._s((_vm.isActive) ? _vm.label : _vm.sleepLabel))])}
var SwitchButton_staticRenderFns = []
var SwitchButton_esExports = { render: SwitchButton_render, staticRenderFns: SwitchButton_staticRenderFns }
/* harmony default export */ var sub_SwitchButton = (SwitchButton_esExports);
// CONCATENATED MODULE: ./src/components/sub/SwitchButton.vue
function SwitchButton_injectStyle (ssrContext) {
  __webpack_require__("bXbE")
}
var SwitchButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SwitchButton___vue_template_functional__ = false
/* styles */
var SwitchButton___vue_styles__ = SwitchButton_injectStyle
/* scopeId */
var SwitchButton___vue_scopeId__ = "data-v-0b5964ac"
/* moduleIdentifier (server only) */
var SwitchButton___vue_module_identifier__ = null
var SwitchButton_Component = SwitchButton_normalizeComponent(
  SwitchButton,
  sub_SwitchButton,
  SwitchButton___vue_template_functional__,
  SwitchButton___vue_styles__,
  SwitchButton___vue_scopeId__,
  SwitchButton___vue_module_identifier__
)

/* harmony default export */ var components_sub_SwitchButton = (SwitchButton_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/AnimatingModal.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var AnimatingModal = ({
  name: 'animatingModal',
  props: {
    title: String,
    isActive: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    wrapperClassObj: function wrapperClassObj() {
      return {
        'animating-modal_wrapper': true
        // 'animated': true,
        // 'fadeInUp': this.isActive, // 出現
        // 'fadeOutUp': (this.isActive == false), // 消える
      };
    }
  },
  methods: {
    onPushClose: function onPushClose() {
      this.$emit('closed');
    }
  },
  mounted: function mounted() {
    // bodyがスクロールしないようにする
    this.$el.addEventListener('touchmove', function (e) {
      if (e.target.type === 'range') {
        e.stopPropagation();
      } else {
        e.preventDefault();
      }
    }, false);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31697134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/AnimatingModal.vue
var AnimatingModal_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"collapse"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],class:_vm.wrapperClassObj},[_c('div',{staticClass:"animating-modal_overlay",on:{"click":_vm.onPushClose}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isActive),expression:"isActive"}],staticClass:"animating-modal_content"},[_c('div',{staticClass:"modal-header"},[_c('div',{staticClass:"close-button",on:{"click":_vm.onPushClose}},[_vm._v("Χ")]),_vm._v(" "),(_vm.title)?_c('h3',[_vm._v(_vm._s(_vm.title))]):_vm._e()]),_vm._v(" "),_vm._t("default")],2)])])}
var AnimatingModal_staticRenderFns = []
var AnimatingModal_esExports = { render: AnimatingModal_render, staticRenderFns: AnimatingModal_staticRenderFns }
/* harmony default export */ var sub_AnimatingModal = (AnimatingModal_esExports);
// CONCATENATED MODULE: ./src/components/sub/AnimatingModal.vue
function AnimatingModal_injectStyle (ssrContext) {
  __webpack_require__("V7UB")
}
var AnimatingModal_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AnimatingModal___vue_template_functional__ = false
/* styles */
var AnimatingModal___vue_styles__ = AnimatingModal_injectStyle
/* scopeId */
var AnimatingModal___vue_scopeId__ = "data-v-31697134"
/* moduleIdentifier (server only) */
var AnimatingModal___vue_module_identifier__ = null
var AnimatingModal_Component = AnimatingModal_normalizeComponent(
  AnimatingModal,
  sub_AnimatingModal,
  AnimatingModal___vue_template_functional__,
  AnimatingModal___vue_styles__,
  AnimatingModal___vue_scopeId__,
  AnimatingModal___vue_module_identifier__
)

/* harmony default export */ var components_sub_AnimatingModal = (AnimatingModal_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/inputRange.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var inputRange = ({
  name: 'inputRange',
  props: {
    value: Number,
    step: Number,
    rangeMax: Number,
    rangeMin: Number,
    buttonStyle: {
      default: function _default() {
        return {
          backgroundColor: "#C1C3C5",
          color: "#4A4E50"
        };
      },

      type: Object
    }
  },

  data: function data() {
    return {};
  },


  methods: {
    onPressDecrement: function onPressDecrement() {
      this.fire(this.value - this.step);
    },
    onPressIncrement: function onPressIncrement() {
      this.fire(this.value + this.step);
    },
    onChangeRange: function onChangeRange(e) {
      this.fire(Number(e.target.value));
    },
    fire: function fire(newVal) {
      this.$emit('change', newVal);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca65b1fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/inputRange.vue
var inputRange_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-range_wrapper"},[_c('div',{staticClass:"mod-button",style:(_vm.buttonStyle),on:{"click":_vm.onPressDecrement}},[_vm._v("«")]),_vm._v(" "),_c('span',{staticClass:"slider-wrapper"},[_c('input',{staticClass:"input-range",attrs:{"type":"range","step":_vm.step,"min":_vm.rangeMin,"max":_vm.rangeMax},domProps:{"value":_vm.value},on:{"change":_vm.onChangeRange}}),_vm._v(" "),_c('span',{staticClass:"slider-scale left-end"},[_vm._v(_vm._s(_vm.rangeMin))]),_vm._v(" "),_c('span',{staticClass:"slider-scale center"},[_vm._v("0")]),_vm._v(" "),_c('span',{staticClass:"slider-scale right-end"},[_vm._v("+"+_vm._s(_vm.rangeMax))]),_vm._v(" "),_c('span',{staticClass:"slider-current-value"},[_vm._v(_vm._s(_vm.value))])]),_vm._v(" "),_c('div',{staticClass:"mod-button",style:(_vm.buttonStyle),on:{"click":_vm.onPressIncrement}},[_vm._v("»")])])}
var inputRange_staticRenderFns = []
var inputRange_esExports = { render: inputRange_render, staticRenderFns: inputRange_staticRenderFns }
/* harmony default export */ var sub_inputRange = (inputRange_esExports);
// CONCATENATED MODULE: ./src/components/sub/inputRange.vue
function inputRange_injectStyle (ssrContext) {
  __webpack_require__("ihbT")
}
var inputRange_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var inputRange___vue_template_functional__ = false
/* styles */
var inputRange___vue_styles__ = inputRange_injectStyle
/* scopeId */
var inputRange___vue_scopeId__ = "data-v-ca65b1fe"
/* moduleIdentifier (server only) */
var inputRange___vue_module_identifier__ = null
var inputRange_Component = inputRange_normalizeComponent(
  inputRange,
  sub_inputRange,
  inputRange___vue_template_functional__,
  inputRange___vue_styles__,
  inputRange___vue_scopeId__,
  inputRange___vue_module_identifier__
)

/* harmony default export */ var components_sub_inputRange = (inputRange_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/NumberVariator.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var NumberVariator = ({
  name: 'numberVariator',
  components: {},
  props: {
    step: {
      default: 1,
      type: Number
    },
    digits: {
      default: 1,
      type: Number
    },
    value: {
      default: 0,
      type: Number
    },
    buttonCssClass: {
      type: String
    }
  },
  computed: {
    buttonClassString: function buttonClassString() {
      return "mod-button " + this.buttonCssClass;
    },
    displayedValue: function displayedValue() {
      var valString = this.value.toFixed(this.digits);
      if (this.value > 0) {
        return "+" + valString;
      } else {
        return valString;
      }
    }
  },
  methods: {
    onPressDecrement: function onPressDecrement() {
      this.fireChange(this.value - this.step);
    },
    onPressIncrement: function onPressIncrement() {
      this.fireChange(this.value + this.step);
    },
    fireChange: function fireChange(newVal) {
      this.$emit('change', newVal);
    }
  }
  // created() {
  // },
  // mounted() {
  // },
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-645c2ea6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/NumberVariator.vue
var NumberVariator_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"number-variator_wrapper"},[_c('div',{class:_vm.buttonClassString,on:{"click":_vm.onPressDecrement}},[_c('i')]),_vm._v(" "),_c('div',{staticClass:"number-container"},[_c('span',[_vm._v(_vm._s(_vm.displayedValue))])]),_vm._v(" "),_c('div',{class:_vm.buttonClassString,on:{"click":_vm.onPressIncrement}},[_c('i'),_c('i')])])}
var NumberVariator_staticRenderFns = []
var NumberVariator_esExports = { render: NumberVariator_render, staticRenderFns: NumberVariator_staticRenderFns }
/* harmony default export */ var sub_NumberVariator = (NumberVariator_esExports);
// CONCATENATED MODULE: ./src/components/sub/NumberVariator.vue
function NumberVariator_injectStyle (ssrContext) {
  __webpack_require__("/nQJ")
}
var NumberVariator_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NumberVariator___vue_template_functional__ = false
/* styles */
var NumberVariator___vue_styles__ = NumberVariator_injectStyle
/* scopeId */
var NumberVariator___vue_scopeId__ = "data-v-645c2ea6"
/* moduleIdentifier (server only) */
var NumberVariator___vue_module_identifier__ = null
var NumberVariator_Component = NumberVariator_normalizeComponent(
  NumberVariator,
  sub_NumberVariator,
  NumberVariator___vue_template_functional__,
  NumberVariator___vue_styles__,
  NumberVariator___vue_scopeId__,
  NumberVariator___vue_module_identifier__
)

/* harmony default export */ var components_sub_NumberVariator = (NumberVariator_Component.exports);

// EXTERNAL MODULE: ./node_modules/store/dist/store.modern.js
var store_modern = __webpack_require__("EJi1");
var store_modern_default = /*#__PURE__*/__webpack_require__.n(store_modern);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/UserOptionForm.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var UserOptionForm_pxb = window.pxb;






/* load user option data from localStorage */
var userData = store_modern_default.a.get(USER_DATA_STORE_KEY) || {};
Object.defineProperty(userData, 'save', {
  value: function value(prop, _value) {
    this[prop] = _value;
    store_modern_default.a.set(USER_DATA_STORE_KEY, this);
  }
});
/* set to pxb-core */
keys_default()(userData).forEach(function (prop) {
  if (userData[prop] && UserOptionForm_pxb.GameManager.hasOwnProperty(prop)) UserOptionForm_pxb.GameManager[prop] = userData[prop];
});
/* Debug: key command to reset to default */
document.addEventListener('keydown', function (e) {
  var kc = e.keyCode;
  /* shift + ctrl + alt + l(76) */
  if (e.shiftKey && e.ctrlKey && e.ctrlKey && kc === 76) {
    store_modern_default.a.set(USER_DATA_STORE_KEY, {});
    console.log('USER DATA clear');
  }
}, false);
// console.log(userData);

/* harmony default export */ var UserOptionForm = ({
  name: 'userOptionForm',
  components: {
    inputRange: components_sub_inputRange,
    switchButton: components_sub_SwitchButton,
    numberVariator: components_sub_NumberVariator
  },
  data: function data() {
    return {
      USER_TIMING_RANGE: 200,
      soundThemes: [].concat(UserOptionForm_pxb.SOUND_THEMES),
      skinTypes: [].concat(UserOptionForm_pxb.SKINS),
      currentSoundTheme: UserOptionForm_pxb.GameManager.soundTheme,
      currentSkinName: UserOptionForm_pxb.GameManager.skinName,
      userSpeed: UserOptionForm_pxb.GameManager.userSpeed || 0,
      userTiming: UserOptionForm_pxb.GameManager.userTiming || 0,
      liteMode: UserOptionForm_pxb.GameManager.liteMode || false,
      debugMode: UserOptionForm_pxb.GameManager.debugMode || false,
      autoPlay: UserOptionForm_pxb.GameManager.autoPlay || false
    };
  },


  methods: {
    onChangeNoteSpeed: function onChangeNoteSpeed(newVal) {
      UserOptionForm_pxb.GameManager.userSpeed = this.userSpeed = Number(newVal);
      userData.save('userSpeed', UserOptionForm_pxb.GameManager.userSpeed);
    },
    onChangeTiming: function onChangeTiming(newVal) {
      UserOptionForm_pxb.GameManager.userTiming = this.userTiming = Number(newVal);
      userData.save('userTiming', UserOptionForm_pxb.GameManager.userTiming);
    },
    onChangeSoundTheme: function onChangeSoundTheme(e) {
      var val = String(e.target.value);
      this.currentSoundTheme = UserOptionForm_pxb.GameManager.soundTheme = val;
      userData.save('soundTheme', UserOptionForm_pxb.GameManager.soundTheme);
    },
    onChangeSkinTheme: function onChangeSkinTheme(e) {
      var val = String(e.target.value);
      this.currentSkinName = UserOptionForm_pxb.GameManager.skinName = val;
      userData.save('skinName', UserOptionForm_pxb.GameManager.skinName);
    },
    toggleLiteMode: function toggleLiteMode() {
      this.liteMode = !this.liteMode;
      UserOptionForm_pxb.GameManager.liteMode = this.liteMode;
      userData.save('liteMode', UserOptionForm_pxb.GameManager.liteMode);
    },
    toggleAutoPlay: function toggleAutoPlay() {
      this.autoPlay = !this.autoPlay;
      UserOptionForm_pxb.GameManager.autoPlay = this.autoPlay;
      userData.save('autoPlay', UserOptionForm_pxb.GameManager.autoPlay);
    },
    toggleDebugMode: function toggleDebugMode() {
      this.debugMode = !this.debugMode;
      UserOptionForm_pxb.GameManager.debugMode = this.debugMode;
      userData.save('debugMode', UserOptionForm_pxb.GameManager.debugMode);
    }
  },

  created: function created() {
    var _this = this;

    /* pxb側で変化したときに値が取れないのでphina.$watchで監視 */
    UserOptionForm_pxb.GameManager.$watch('userSpeed', function (newVal, oldVal) {
      if (newVal !== oldVal) _this.userSpeed = newVal;
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f382293","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserOptionForm.vue
var UserOptionForm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-option_wrapper"},[_c('table',{staticClass:"user-option_table"},[_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("NOTE-SPEED")]),_c('td',{staticClass:"content"},[_c('numberVariator',{attrs:{"value":_vm.userSpeed,"step":0.5,"buttonCssClass":"t-lightgreen"},on:{"change":_vm.onChangeNoteSpeed}})],1)]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("TIMING(msec)")]),_c('td',{staticClass:"content"},[_c('input-range',{attrs:{"step":1,"rangeMin":-_vm.USER_TIMING_RANGE,"rangeMax":_vm.USER_TIMING_RANGE,"value":_vm.userTiming},on:{"change":_vm.onChangeTiming}})],1)]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("SE")]),_c('td',{staticClass:"content"},[_c('select',{on:{"change":_vm.onChangeSoundTheme}},_vm._l((_vm.soundThemes),function(item,index){return _c('option',{domProps:{"value":item.key,"selected":_vm.currentSoundTheme === item.key}},[_vm._v(_vm._s(item.label))])}))])]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("SKIN")]),_c('td',{staticClass:"content"},[_c('select',{on:{"change":_vm.onChangeSkinTheme}},_vm._l((_vm.skinTypes),function(item,index){return _c('option',{domProps:{"value":item.key,"selected":_vm.currentSkinName === item.key}},[_vm._v(_vm._s(item.label))])}))])]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("LITE MODE")]),_c('td',{staticClass:"content"},[_c('switch-button',{attrs:{"isActive":_vm.liteMode},on:{"click":_vm.toggleLiteMode}})],1)]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("AUTO PLAY")]),_c('td',{staticClass:"content"},[_c('switch-button',{attrs:{"isActive":_vm.autoPlay},on:{"click":_vm.toggleAutoPlay}})],1)]),_c('tr',[_c('td',{staticClass:"heading"},[_vm._v("DEBUG MODE")]),_c('td',{staticClass:"content"},[_c('switch-button',{attrs:{"isActive":_vm.debugMode},on:{"click":_vm.toggleDebugMode}})],1)])])])}
var UserOptionForm_staticRenderFns = []
var UserOptionForm_esExports = { render: UserOptionForm_render, staticRenderFns: UserOptionForm_staticRenderFns }
/* harmony default export */ var components_UserOptionForm = (UserOptionForm_esExports);
// CONCATENATED MODULE: ./src/components/UserOptionForm.vue
function UserOptionForm_injectStyle (ssrContext) {
  __webpack_require__("0ocF")
}
var UserOptionForm_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var UserOptionForm___vue_template_functional__ = false
/* styles */
var UserOptionForm___vue_styles__ = UserOptionForm_injectStyle
/* scopeId */
var UserOptionForm___vue_scopeId__ = "data-v-5f382293"
/* moduleIdentifier (server only) */
var UserOptionForm___vue_module_identifier__ = null
var UserOptionForm_Component = UserOptionForm_normalizeComponent(
  UserOptionForm,
  components_UserOptionForm,
  UserOptionForm___vue_template_functional__,
  UserOptionForm___vue_styles__,
  UserOptionForm___vue_scopeId__,
  UserOptionForm___vue_module_identifier__
)

/* harmony default export */ var src_components_UserOptionForm = (UserOptionForm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GlobalNav.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var GlobalNav = ({
  name: 'globalNav',
  components: {
    switchButton: components_sub_SwitchButton,
    animatingModal: components_sub_AnimatingModal,
    userOptionForm: src_components_UserOptionForm
  },
  data: function data() {
    return {
      isUserOptionOpen: false
      // isUserOptionOpen: true,
    };
  },


  methods: {
    openUserOption: function openUserOption(e) {
      this.isUserOptionOpen = true;
    },
    closeUserOption: function closeUserOption(e) {
      this.isUserOptionOpen = false;
    }
  }

  // created() {
  // GameManagerの参照をもたせるとpxb起動中、異様に重くなってしまうので避ける
  // this.pxbGM = pxb.GameManager;
  // },
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c66cf192","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GlobalNav.vue
var GlobalNav_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"globalNav"},[_c('nav',{staticClass:"globalNav_container"},[_c('ul',{staticClass:"globalNav_links"},_vm._l((_vm.$router.options.routes),function(item,index){return (item.label)?_c('li',[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.label))])],1):_vm._e()})),_c('ul',{staticClass:"globalNav_options"},[_c('li',[_c('i',{staticClass:"material-icons",on:{"click":_vm.openUserOption}},[_vm._v("settings")])])])]),_c('animatingModal',{attrs:{"title":"GAME OPTION","isActive":_vm.isUserOptionOpen},on:{"closed":_vm.closeUserOption}},[_c('userOptionForm')],1)],1)}
var GlobalNav_staticRenderFns = []
var GlobalNav_esExports = { render: GlobalNav_render, staticRenderFns: GlobalNav_staticRenderFns }
/* harmony default export */ var components_GlobalNav = (GlobalNav_esExports);
// CONCATENATED MODULE: ./src/components/GlobalNav.vue
function GlobalNav_injectStyle (ssrContext) {
  __webpack_require__("7L41")
}
var GlobalNav_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GlobalNav___vue_template_functional__ = false
/* styles */
var GlobalNav___vue_styles__ = GlobalNav_injectStyle
/* scopeId */
var GlobalNav___vue_scopeId__ = "data-v-c66cf192"
/* moduleIdentifier (server only) */
var GlobalNav___vue_module_identifier__ = null
var GlobalNav_Component = GlobalNav_normalizeComponent(
  GlobalNav,
  components_GlobalNav,
  GlobalNav___vue_template_functional__,
  GlobalNav___vue_styles__,
  GlobalNav___vue_scopeId__,
  GlobalNav___vue_module_identifier__
)

/* harmony default export */ var src_components_GlobalNav = (GlobalNav_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var Header = ({
  name: 'pxb-header',
  components: {
    globalNav: src_components_GlobalNav
  },
  data: function data() {
    return {
      title: SITE_NAME,
      version: SITE_VER
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-44fc1d0c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
var Header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"u-mb-md"},[_c('div',{staticClass:"inner"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":__webpack_require__("iQH9")}})]),_vm._v(" "),_c('section',{staticClass:"t-white-s"},[_c('h1',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('h4',[_vm._v("-"+_vm._s(_vm.version)+"-")])])],1),_vm._v(" "),_c('global-nav')],1)}
var Header_staticRenderFns = []
var Header_esExports = { render: Header_render, staticRenderFns: Header_staticRenderFns }
/* harmony default export */ var components_Header = (Header_esExports);
// CONCATENATED MODULE: ./src/components/Header.vue
function Header_injectStyle (ssrContext) {
  __webpack_require__("xWVD")
}
var Header_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Header___vue_template_functional__ = false
/* styles */
var Header___vue_styles__ = Header_injectStyle
/* scopeId */
var Header___vue_scopeId__ = "data-v-44fc1d0c"
/* moduleIdentifier (server only) */
var Header___vue_module_identifier__ = null
var Header_Component = Header_normalizeComponent(
  Header,
  components_Header,
  Header___vue_template_functional__,
  Header___vue_styles__,
  Header___vue_scopeId__,
  Header___vue_module_identifier__
)

/* harmony default export */ var src_components_Header = (Header_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/InputFileField.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 子要素にdragenterしてチカチカさせない
// ref: https://qiita.com/sounisi5011/items/dc4878d3e8b38101cf0b
var innerFlag = false;

/* harmony default export */ var InputFileField = ({
  name: 'inputFileField',
  props: {
    width: Number,
    height: Number
  },

  data: function data() {
    return {
      id: null,
      isCovered: false
    };
  },


  computed: {
    styleObject: function styleObject() {
      return {
        margin: '10px',
        width: this.width + 'px',
        height: this.height + 'px'
      };
    },
    classObject: function classObject() {
      return {
        // "t-gray-b": true,
        "t-pastelgreen-b": true,
        dragover: this.isCovered
      };
    }
  },

  mounted: function mounted() {
    // label forのため、ユニークIDを指定
    this.id = this._uid;
  },


  methods: {
    onInputChange: function onInputChange(evt) {
      // console.log('chg evt', evt)
      this.$emit('change', evt);
    },
    onDrop: function onDrop(evt) {
      this.isCovered = false;
      // evt.preventDefault();
      // evt.stopPropagation();
      this.$emit('drop', evt);
    },
    onDragEnter: function onDragEnter(evt) {
      // console.log('enter')
      innerFlag = true;
    },
    onDragOver: function onDragOver(evt) {
      innerFlag = false;
      this.isCovered = true;
    },
    onDragLeave: function onDragLeave(evt) {
      // console.log('exit')
      if (innerFlag) {
        //フラグがセットされている場合、フラグを戻す
        innerFlag = false;
      } else {
        //フラグがセットされていない場合、クラスを削除
        this.isCovered = false;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac03fbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/InputFileField.vue
var InputFileField_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{class:_vm.classObject,style:(_vm.styleObject),attrs:{"for":_vm.id},on:{"dragenter":_vm.onDragEnter,"dragover":_vm.onDragOver,"dragleave":_vm.onDragLeave,"drop":_vm.onDrop}},[_c('section',{staticClass:"label-inner"},[_vm._m(0,false,false),_vm._v(" "),_vm._m(1,false,false),_vm._v(" "),(_vm.isCovered)?_c('div',[_vm._v("\n        ドロップ！\n      ")]):_vm._e()])]),_vm._v(" "),_c('input',{attrs:{"type":"file","id":_vm.id},on:{"change":_vm.onInputChange}})])}
var InputFileField_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-area"},[_c('i',{staticClass:"material-icons md-48"},[_vm._v("folder_open")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("pxbpファイルと音源ファイルの"),_c('br'),_vm._v("選択・ロード")])}]
var InputFileField_esExports = { render: InputFileField_render, staticRenderFns: InputFileField_staticRenderFns }
/* harmony default export */ var sub_InputFileField = (InputFileField_esExports);
// CONCATENATED MODULE: ./src/components/sub/InputFileField.vue
function InputFileField_injectStyle (ssrContext) {
  __webpack_require__("zEgk")
}
var InputFileField_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var InputFileField___vue_template_functional__ = false
/* styles */
var InputFileField___vue_styles__ = InputFileField_injectStyle
/* scopeId */
var InputFileField___vue_scopeId__ = "data-v-1ac03fbc"
/* moduleIdentifier (server only) */
var InputFileField___vue_module_identifier__ = null
var InputFileField_Component = InputFileField_normalizeComponent(
  InputFileField,
  sub_InputFileField,
  InputFileField___vue_template_functional__,
  InputFileField___vue_styles__,
  InputFileField___vue_scopeId__,
  InputFileField___vue_module_identifier__
)

/* harmony default export */ var components_sub_InputFileField = (InputFileField_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/ActivationButton.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ActivationButton = ({
  name: 'activation-button',

  props: {
    label: String,
    classes: String,
    inactive: Boolean,
    width: Number
  },

  computed: {
    styleObject: function styleObject() {
      return {
        width: this.width + "px"
      };
    },
    classObject: function classObject() {
      return {
        // scope: true,
        't-pink scope': true,
        inactive: this.inactive
      };
    }
  },

  methods: {
    onClick: function onClick(e) {
      // console.log('pushed')
      // if (this.inactive) return;
      this.$emit('push', e);
    }
  }

  // data () {
  //   return {  }
  // },
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9e202c8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/ActivationButton.vue
var ActivationButton_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classObject,style:(_vm.styleObject),on:{"click":_vm.onClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var ActivationButton_staticRenderFns = []
var ActivationButton_esExports = { render: ActivationButton_render, staticRenderFns: ActivationButton_staticRenderFns }
/* harmony default export */ var sub_ActivationButton = (ActivationButton_esExports);
// CONCATENATED MODULE: ./src/components/sub/ActivationButton.vue
function ActivationButton_injectStyle (ssrContext) {
  __webpack_require__("Uxpk")
}
var ActivationButton_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ActivationButton___vue_template_functional__ = false
/* styles */
var ActivationButton___vue_styles__ = ActivationButton_injectStyle
/* scopeId */
var ActivationButton___vue_scopeId__ = "data-v-b9e202c8"
/* moduleIdentifier (server only) */
var ActivationButton___vue_module_identifier__ = null
var ActivationButton_Component = ActivationButton_normalizeComponent(
  ActivationButton,
  sub_ActivationButton,
  ActivationButton___vue_template_functional__,
  ActivationButton___vue_styles__,
  ActivationButton___vue_scopeId__,
  ActivationButton___vue_module_identifier__
)

/* harmony default export */ var components_sub_ActivationButton = (ActivationButton_Component.exports);

// EXTERNAL MODULE: ./node_modules/whatwg-fetch/fetch.js
var whatwg_fetch_fetch = __webpack_require__("rplX");
var fetch_default = /*#__PURE__*/__webpack_require__.n(whatwg_fetch_fetch);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/sub/musicJacket.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/**
 * ジャケット画像
 * 画像ソースを渡された場合は画像を、
 * そうでない場合はprojectSrcをAjaxで拾って動的にそれっぽくする
 *
 */


/* harmony default export */ var musicJacket = ({
  name: 'musicJacket',
  props: {
    imgSrc: String,
    projectSrc: String
  },
  data: function data() {
    return {
      projectData: {
        musicName: "",
        artistName: ""
      }
    };
  },

  // computed: {
  //   projectData() {
  //     return this.fetchDetail(this.projectSrc);
  //   }
  // },

  methods: {
    fetchDetail: function fetchDetail(projectPath) {
      var self = this;

      fetch(projectPath).then(function (response) {
        return response.json();
      }).then(function (json) {
        // console.log("fetch", this, json)
        self.projectData = json;
        return json;
      }).catch(function (error) {
        console.error(error);
      });
    },

    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  },

  created: function created() {
    if (!this.imgSrc) {
      // ジャケ画像がない場合
      this.fetchDetail(this.projectSrc);
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d252116","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub/musicJacket.vue
var musicJacket_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-moon--grad scope",on:{"click":_vm.onClick}},[(_vm.imgSrc)?_c('img',{attrs:{"src":_vm.imgSrc}}):_c('div',[_c('span',{staticClass:"no-image-label"},[_vm._v("NO IMAGE")]),_vm._v(" "),_c('div',{staticClass:"labels"},[_c('h3',{staticClass:"topic"},[_vm._v(_vm._s(_vm.projectData.musicName))]),_vm._v(" "),_c('h4',{staticClass:"subtopic"},[_vm._v(_vm._s(_vm.projectData.artistName))])])])])}
var musicJacket_staticRenderFns = []
var musicJacket_esExports = { render: musicJacket_render, staticRenderFns: musicJacket_staticRenderFns }
/* harmony default export */ var sub_musicJacket = (musicJacket_esExports);
// CONCATENATED MODULE: ./src/components/sub/musicJacket.vue
function musicJacket_injectStyle (ssrContext) {
  __webpack_require__("KsKM")
}
var musicJacket_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var musicJacket___vue_template_functional__ = false
/* styles */
var musicJacket___vue_styles__ = musicJacket_injectStyle
/* scopeId */
var musicJacket___vue_scopeId__ = "data-v-4d252116"
/* moduleIdentifier (server only) */
var musicJacket___vue_module_identifier__ = null
var musicJacket_Component = musicJacket_normalizeComponent(
  musicJacket,
  sub_musicJacket,
  musicJacket___vue_template_functional__,
  musicJacket___vue_styles__,
  musicJacket___vue_scopeId__,
  musicJacket___vue_module_identifier__
)

/* harmony default export */ var components_sub_musicJacket = (musicJacket_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MusicList.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/**
 * clickでParentにわたす
 */
/* harmony default export */ var MusicList = ({
  name: 'musicList',
  components: {
    musicJacket: components_sub_musicJacket
  },
  props: {
    projectListData: Array
  },

  methods: {
    onClick: function onClick(musicSrc, projectSrc) {
      this.$emit('click', musicSrc, projectSrc);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30394e38","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MusicList.vue
var MusicList_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-wrapper"},_vm._l((_vm.projectListData),function(item,index){return _c('li',{key:item.id,staticClass:"list-item",on:{"click":function($event){_vm.onClick(item.music, item.project)}}},[_c('music-jacket',{attrs:{"imgSrc":item.jacket,"projectSrc":item.project}})],1)}))}
var MusicList_staticRenderFns = []
var MusicList_esExports = { render: MusicList_render, staticRenderFns: MusicList_staticRenderFns }
/* harmony default export */ var components_MusicList = (MusicList_esExports);
// CONCATENATED MODULE: ./src/components/MusicList.vue
function MusicList_injectStyle (ssrContext) {
  __webpack_require__("i311")
}
var MusicList_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MusicList___vue_template_functional__ = false
/* styles */
var MusicList___vue_styles__ = MusicList_injectStyle
/* scopeId */
var MusicList___vue_scopeId__ = "data-v-30394e38"
/* moduleIdentifier (server only) */
var MusicList___vue_module_identifier__ = null
var MusicList_Component = MusicList_normalizeComponent(
  MusicList,
  components_MusicList,
  MusicList___vue_template_functional__,
  MusicList___vue_styles__,
  MusicList___vue_scopeId__,
  MusicList___vue_module_identifier__
)

/* harmony default export */ var src_components_MusicList = (MusicList_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Home/Home.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import './src/assets/theme.css';




// import musicListData from '@/assets/sample-music-list.json'







/* harmony default export */ var Home = ({
  name: 'home',

  components: {
    pHeader: src_components_Header,
    inputFile: components_sub_InputFileField,
    actbutton: components_sub_ActivationButton,
    musicList: src_components_MusicList
  },

  data: function data() {
    return {
      state: Store.state,
      testerAudio: document.createElement('video'),
      musicListData: sample_music_list_default.a // temp
    };
  },


  computed: {
    musicStatusClassObj: function musicStatusClassObj() {
      return {
        't-moon--dark': true,
        'isActive': this.state.currentMusic
      };
    },
    projectStatusClassObj: function projectStatusClassObj() {
      return {
        't-moon--dark': true,
        'isActive': this.state.currentProject
      };
    },
    isSimRunnable: function isSimRunnable() {
      // return (this.state.currentMusic != null) && (this.state.currentProject != null);
      return this.state.currentMusic != null && this.state.currentProject != null;
    }
  },

  // created () {},

  mounted: function mounted() {
    var _this = this;

    // キー操作設定: ondestroyでremoveする
    document.addEventListener('keydown', function (e) {
      var kc = e.keyCode;
      // f(70) or Tenkey *(106) or \|
      if (e.shiftKey && e.ctrlKey && kc === 70) {
        e.preventDefault();
        _this._testMethod();
      }
    }, false);
  },


  methods: {
    _testMethod: function _testMethod() {
      // run sample
      this.$pxbSim.run('./static/sample/GGAM/music.mp3', './static/sample/GGAM/project.pxbp');
    },
    uploadFile: function uploadFile(evt) {
      var _this2 = this;

      // console.log(evt)

      if (evt.dataTransfer != null) {
        // by DnD
        var files = evt.dataTransfer.files;
      } else if (evt.target != null) {
        // by file selection
        var files = evt.target.files;
      } else {
        return false;
      }

      for (var i = 0, file; file = files[i]; i++) {
        var reader = new FileReader();

        if (file.type && /audio/.test(file.type)) {
          var _ret = function () {
            // Audio file
            var name = file.name;
            if (_this2.testerAudio.canPlayType(file.type) === "") {
              sweetalert_min_default()('Unsupported audio type', '未サポートの音源形式です', "error");
              return 'continue';
            }
            reader.onload = function (e) {
              var dataURL = e.target.result;
              // console.log(dataURL)
              Store.setMusicAction(dataURL, name);
            };
            reader.readAsDataURL(file);
          }();

          if (_ret === 'continue') continue;
        } else if (file.name.indexOf('.' + PROJECT_EXT) != -1) {
          // beatmap
          var name = file.name;
          console.log('project file', file);
          reader.onload = function (e) {
            var rawData = e.target.result;
            var currentProject = JSON.parse(rawData);
            Store.setProjectAction(currentProject, name);
          };
          reader.readAsText(file);
          // } else if (file.type && /image/.test(file.type)) {
          //   // image
          //   console.log('image')
        } else {
          sweetalert_min_default()('Audio file or project (.' + PROJECT_EXT + ') file only.', "オーディオファイルかプロジェクトファイル（.pxbp）を選んで下さい", "error");
        }

        reader.onerror = function (err) {
          sweetalert_min_default()(err, "エラー", "error");
          console.error(err);
        };
        // reader.onload = (function(theFile) {
        //   return function(e) {
        //     var dataURL = e.target.result;
        //   };
        // })(f);
      }
    },
    onPushPlay: function onPushPlay(e) {
      if (this.state.currentMusic == null || this.state.currentProject == null) {
        sweetalert_min_default()("Music or Project file is not set!", "音源ファイルとプロジェクトファイルをセットして下さい", "error");
        return;
      }
      this.$pxbSim.run(this.state.currentMusic, this.state.currentProject);
    },
    onClickMusicJacket: function onClickMusicJacket(musicSrc, projectSrc) {
      this.$pxbSim.run(musicSrc, projectSrc);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02cb033c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/Home/home.html
var home_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p-header'),_vm._v(" "),_c('main',{staticClass:"u-mb-md",attrs:{"role":"main"}},[_c('section',{ref:"upload-area",staticClass:"u-mb-md"},[_c('h2',{staticClass:"p-topic"},[_vm._v("PxB Project")]),_vm._v(" "),_c('section',{staticClass:"t-moon u-mb-sm ff-basic"},[_c('ul',{staticClass:"status-table"},[_c('li',[_c('div',{class:_vm.musicStatusClassObj},[(_vm.state.currentMusic)?_c('i',{staticClass:"material-icons icon"},[_vm._v("check")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("MUSIC: ")]),_vm._v(" "+_vm._s((_vm.state.currentMusic) ? _vm.state.currentMusicName : "NONE")+"\r\n            ")])]),_vm._v(" "),_c('li',[_c('div',{class:_vm.projectStatusClassObj},[(_vm.state.currentProject)?_c('i',{staticClass:"material-icons icon"},[_vm._v("check")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"label"},[_vm._v("BEATMAP: ")]),_vm._v(" "+_vm._s((_vm.state.currentProject) ? _vm.state.currentProjectName : "NONE")+"\r\n            ")])])])]),_vm._v(" "),_c('input-file',{attrs:{"width":350},on:{"change":_vm.uploadFile,"drop":_vm.uploadFile}}),_vm._v(" "),_c('actbutton',{attrs:{"width":290,"label":"PLAY","inactive":!_vm.isSimRunnable},on:{"push":_vm.onPushPlay}})],1),_vm._v(" "),_c('section',[_c('h2',{staticClass:"p-topic"},[_vm._v("PRESET")]),_vm._v(" "),_c('div',{staticClass:"t-moon"},[_c('music-list',{attrs:{"projectListData":_vm.musicListData},on:{"click":_vm.onClickMusicJacket}})],1)])]),_vm._v(" "),_c('footer',{staticClass:"t-moon"})],1)}
var home_staticRenderFns = []
var home_esExports = { render: home_render, staticRenderFns: home_staticRenderFns }
/* harmony default export */ var home = (home_esExports);
// CONCATENATED MODULE: ./src/components/Home/Home.vue
function Home_injectStyle (ssrContext) {
  __webpack_require__("4lmW")
}
var Home_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Home___vue_template_functional__ = false
/* styles */
var Home___vue_styles__ = Home_injectStyle
/* scopeId */
var Home___vue_scopeId__ = "data-v-02cb033c"
/* moduleIdentifier (server only) */
var Home___vue_module_identifier__ = null
var Home_Component = Home_normalizeComponent(
  Home,
  home,
  Home___vue_template_functional__,
  Home___vue_styles__,
  Home___vue_scopeId__,
  Home___vue_module_identifier__
)

/* harmony default export */ var Home_Home = (Home_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// CONCATENATED MODULE: ./src/Utils.js

/**
 * base64エンコード/デコードした文字列を返す
 * @param  {String}  string   [description]
 * @param  {Boolean} isDecode [description]
 * @return {String}           [description]
 */
var Utils_getBase64ConvertedString = function getBase64ConvertedString(string, isDecode) {
  // const ENCODE_API_URL = 'http://localhost:5001/sound-player-sample/us-central1/encode';
  // const DECODE_API_URL = 'http://localhost:5001/sound-player-sample/us-central1/decode';

  /* cli ver */
  var Base64 = {
    encode: function encode(str) {
      return btoa(unescape(encodeURIComponent(str)));
    },
    decode: function decode(str) {
      return decodeURIComponent(escape(atob(str)));
    }
  };
  var convert = isDecode ? Base64.decode : Base64.encode;
  return new promise_default.a(function (resolve, reject) {
    var converted = void 0;
    try {
      converted = convert(string);
    } catch (e) {
      reject({
        title: "CONVERT ERROR",
        text: "文字列変換に失敗しました",
        icon: "error"
      });
    }
    resolve(converted);
  });

  /* server gzip+base64 */
  // const queryURL = (isDecode) ? DECODE_API_URL : ENCODE_API_URL
  // return fetch(queryURL, {
  //   method : 'POST',
  //   body : string,
  // }).then(response => {
  //   return response.text();
  // });

  // /* simple euc/duc */
  // const convert = (isDecode) ? decodeURIComponent : encodeURIComponent;
  // return new Promise(function(resolve, reject) {
  //   resolve(convert(string));
  // });
};

/**
 * createTwitterShareLink
 * @param  {String} text
 * @param  {String} url
 * @param  {Array} hashtags
 * @return {String} Twitter share URL
 */
var createTwitterShareLink = function createTwitterShareLink(text, url, hashtags) {
  var BASE_URL = 'https://twitter.com/share';
  var euc = encodeURIComponent;
  var queries = ["text=" + euc(text)];
  if (url) queries.push("url=" + euc(url));
  if (hashtags) queries.push("hashtags=" + euc(hashtags.join(',')));

  return BASE_URL + "?" + queries.join('&');
};
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SharePlayer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SHARE_HASH_TAGS = ["pxb_playground"];
var _validateMusicSrc = function _validateMusicSrc(musicSrc) {
  return (/\.mp3$/.test(musicSrc)
  );
};
var SharePlayer__validateProjectSrc = function _validateProjectSrc(src) {
  var regexp = new RegExp('\.' + PROJECT_EXT + '$');
  return regexp.test(src);
};
var _replaceURL = function _replaceURL(urlString) {
  // クエリパラメータ省く＆dropbox直リンクを得る
  return urlString.replace(/\?.*$/, "").replace('www.dropbox', 'dl.dropboxusercontent');
};
var SharePlayer_errorHandler = function errorHandler(error) {
  if (typeof error === 'string') {
    sweetalert_min_default()(error);
  } else {
    if (error.message && error.message.match(/JSON/)) {
      sweetalert_min_default()("INVALID PROJECT", "不正なpxbpファイルです", "error");
    } else if (error.text) {
      sweetalert_min_default()(error);
    }
  }
};



/* harmony default export */ var SharePlayer = ({
  name: 'template',
  components: {
    pHeader: src_components_Header,
    actbutton: components_sub_ActivationButton
  },

  data: function data() {
    return {
      isParsing: false,
      isCreatingLink: false,
      shareLinkURL: "",
      // shareLinkURL: "for debugging",
      musicStatusMessage: "",
      // twitterShareURL: "",
      cachedMusicSrc: "",
      cachedProjectSrc: "",
      currentMusic: null,
      currentProjectSrc: null, // string
      currentProjectObj: null // Object
    };
  },

  computed: {
    musicData: function musicData() {
      var params = this.currentProjectObj || {};
      return {
        name: params.musicName || "--",
        artist: params.artistName || "--",
        level: params.musicLevel || "--",
        category: params.category.toUpperCase() || "--"
      };
    },
    isSimRunnable: function isSimRunnable() {
      return this.currentMusic != null && this.currentProjectSrc != null;
    }
  },

  methods: {
    /**
     * 音源読み込み
     * @param  {String} src
     * @return {Promise}
     */
    _loadMusic: function _loadMusic(src) {
      var _this = this;

      // from pxb-core holwer
      if (window.Howl) {
        return new promise_default.a(function (resolve, reject) {
          var _music = new Howl({ src: [src] });
          _this.musicStatusMessage = "Loading Music...";
          _music.once('load', function () {
            _this.musicStatusMessage = "";
            _this.currentMusic = _music;
            resolve();
          });
          _music.on('loaderror', function () {
            _this.musicStatusMessage = "";
            reject({
              title: "MUSIC LOAD ERROR",
              text: "音楽のロードに失敗しました",
              icon: "error"
            });
          });
        });
      } else {
        var audio = new Audio();
        audio.src = src;
        audio.load(); // iosは明示的loadが必要
        return new promise_default.a(function (resolve, reject) {
          audio.onloadeddata = function () {
            // console.log('sound loaded');
            _this.currentMusic = src;
            resolve(src);
          };
          audio.onerror = function (e) {
            reject({
              title: "MUSIC LOAD ERROR",
              text: "音楽のロードに失敗しました",
              icon: "error"
            });
          };
        });
      }
    },

    /**
     * プロジェクト読み込み
     * @param  {String} src
     * @return {Promise}
     */
    _loadProject: function _loadProject(src) {
      var _this2 = this;

      return fetch(src).then(function (response) {
        // if (true) {
        if (!response.ok) {
          throw {
            title: "SERVER RESPONSE ERROR",
            text: "プロジェクトファイル取得に失敗しました",
            icon: "error",
            _message: response.text
          };
        }
        return response.json();
      }).then(function (json) {
        _this2.currentProjectSrc = src;
        _this2.currentProjectObj = json;
      });
    },

    /**
     * プロジェクトのセットアップ
     * @param  {String} musicSrc
     * @param  {String} projectSrc
     * @return {Promise}
     */
    setupProject: function setupProject(musicSrc, projectSrc) {
      return promise_default.a.all([this._loadMusic(musicSrc), this._loadProject(projectSrc)]);
    },
    _createShareURL: function _createShareURL() {
      this.shareLinkURL = location.href;
      var data = this.musicData;
      var message = data.name + ' / ' + data.artist + ' | Lv:' + data.level + ' | ' + data.category;
      // this.twitterShareURL = createTwitterShareLink(message, location.href, SHARE_HASH_TAGS);
    },


    /**
     * createShareLink
     * 音楽・プロジェクトURLをbase64エンコード
     * -> クエリパラメータとしたURLを生成
     * @return {void}
     */
    createShareLink: function createShareLink() {
      var _this3 = this;

      if (this.isCreatingLink || this.isParsing) return;

      var musicSrc = _replaceURL(this.$refs.musicSrcInput.value);
      var projectSrc = _replaceURL(this.$refs.projectInput.value);
      if (!musicSrc || !projectSrc) {
        sweetalert_min_default()('NO INPUT', '未入力の項目があります', "error");
        return;
      }
      if (!_validateMusicSrc(musicSrc)) {
        sweetalert_min_default()('MP3 ONLY', 'mp3ファイルを指定して下さい', "error");
        return;
      }
      if (!SharePlayer__validateProjectSrc(projectSrc)) {
        sweetalert_min_default()('PXBP ONLY', 'Projectには.pxbpファイルを指定して下さい', "error");
        return;
      }

      // キャッシュと比較して値に変更がなければ何もしない
      if (musicSrc === this.cachedMusicSrc && projectSrc === this.cachedProjectSrc) return;

      // console.log("creating link...");
      this.isCreatingLink = true;
      this.cachedMusicSrc = musicSrc;
      this.cachedProjectSrc = projectSrc;

      /* サウンドをテスト+プロジェクト展開 -> base64化 -> シェアURL生成 */
      this.setupProject(musicSrc, projectSrc).then(function () {
        return promise_default.a.all([Utils_getBase64ConvertedString(musicSrc), Utils_getBase64ConvertedString(projectSrc)]);
      }).then(function (values) {
        _this3.isCreatingLink = false;
        var encodedParams = {
          music: values[0],
          project: values[1]
        };

        /* シェアリンク作成 */
        _this3.$router.replace({ query: encodedParams });
        _this3._createShareURL();
        // console.log("url length:", location.href.length);
      }).catch(function (err) {
        SharePlayer_errorHandler(err);
        _this3.isCreatingLink = false;
      });
    },


    /**
     * parseQueryParams
     * クエリパラメータをパースしてbase64デコード
     * @return {void}
     */
    parseQueryParams: function parseQueryParams() {
      var _this4 = this;

      var params = this.$route.query;
      if (params.music == null || params.project == null) {
        // console.log(params, 'no params');
        return;
      };

      /* base64デコード -> サウンドをテスト+プロジェクト展開 */
      this.isParsing = true;
      promise_default.a.all([Utils_getBase64ConvertedString(params.music, true), Utils_getBase64ConvertedString(params.project, true)]).then(function (values) {
        // console.log("parsed vals", values);
        return _this4.setupProject(values[0], values[1]);
      }).then(function (res) {
        _this4.isParsing = false;
        // this._createShareURL(); // For debug
      }).catch(function (err) {
        SharePlayer_errorHandler(err);
        _this4.isParsing = false;
      });
    },
    onClickCopy: function onClickCopy() {
      try {
        this.$refs.shareURLtextArea.select();
        document.execCommand("copy");
        sweetalert_min_default()('COPIED!', 'クリップボードへコピーしました');
      } catch (e) {
        sweetalert_min_default()('COPY FAIL', 'コピーできませんでした。ブラウザが対応していません', "error");
      }
    },


    /* シミュレーター起動 */
    bootSimApp: function bootSimApp() {
      if (this.currentMusic == null) {
        sweetalert_min_default()('No Music', '音源がありません', "error");
        return;
      }
      if (this.currentProjectSrc == null) {
        sweetalert_min_default()('NO PROJECT', 'プロジェクトがありません', "error");
        return;
      }
      this.$pxbSim.run(this.currentMusic, this.currentProjectSrc);
    }
  },

  created: function created() {
    this.parseQueryParams();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59f6e97a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SharePlayer.vue
var SharePlayer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scope"},[_c('p-header'),_c('main',{attrs:{"role":"main"}},[_c('h2',{staticClass:"p-topic u-mb-sm"},[_vm._v("PxB Share Player")]),(_vm.currentProjectObj)?_c('section',{staticClass:"t-moon--grad music-info-area"},[_c('h3',{staticClass:"p-topic_small"},[_vm._v("MUSIC")]),_c('table',{staticClass:"music-table u-mb-sm"},_vm._l((_vm.musicData),function(value,key,index){return _c('tr',[_c('th',{staticClass:"t-moon"},[_vm._v(_vm._s(key.toUpperCase()))]),_c('td',{staticClass:"t-lightgreen"},[_vm._v(_vm._s(value))])])})),_c('actbutton',{attrs:{"width":240,"label":"PLAY","inactive":!_vm.isSimRunnable},on:{"push":_vm.bootSimApp}}),(_vm.musicStatusMessage)?_c('div',{staticClass:"load-message"},[_vm._v(_vm._s(_vm.musicStatusMessage))]):_vm._e()],1):_vm._e(),_c('section',{staticClass:"t-pastelgreen-b"},[_c('h3',{staticClass:"p-topic_small"},[_vm._v("PROJECT SET UP")]),_c('ul',{staticClass:"data-input-field"},[_c('li',[_c('h4',[_vm._v("MUSIC")]),_c('input',{ref:"musicSrcInput",staticClass:"input-text t-moon--dark",attrs:{"type":"url","placeholder":"音源(mp3)のアップロード先URLを入力"}})]),_c('li',[_c('h4',[_vm._v("PxB PROJECT")]),_c('input',{ref:"projectInput",staticClass:"input-text t-moon--dark",attrs:{"type":"url","placeholder":"pxbpファイルのアップロード先URLを入力"}})]),_c('li',[_c('actbutton',{attrs:{"width":240,"label":"SET UP","inactive":_vm.isCreatingLink},on:{"push":_vm.createShareLink}})],1)]),(_vm.isCreatingLink)?_c('div',{staticClass:"load-message"},[_vm._v("Creating Link...")]):_vm._e(),(_vm.shareLinkURL !== '')?_c('section',{staticClass:"t-purple neutralize-anchor"},[_c('ul',{staticClass:"command-list"},[_c('li',{attrs:{"title":"copy"},on:{"click":_vm.onClickCopy}},[_c('i',{staticClass:"icon ion-ios-copy"})])]),_c('textarea',{ref:"shareURLtextArea",staticClass:"textarea",attrs:{"readonly":"readonly"},domProps:{"value":_vm.shareLinkURL}})]):_vm._e(),_vm._m(0,false,false)])])],1)}
var SharePlayer_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"t-moon"},[_c('h3',{staticClass:"p-topic_small"},[_vm._v("HOW TO SET UP")]),_c('ol',{staticClass:"u-mb-sm"},[_c('li',[_c('a',{attrs:{"href":"https://www.dropbox.com/","target":"_new"}},[_vm._v("Dropbox")]),_vm._v("のアカウントを作ります（無料）")]),_c('li',[_vm._v("音源ファイル（mp3のみ）とpxbpファイルをdropboxにアップロードします")]),_c('li',[_vm._v("それぞれのファイルで「共有」→「リンクの作成」でURLを取得します")]),_c('li',[_vm._v("取得したURLをそれぞれペーストし、「SET UP」を押します")]),_c('li',[_vm._v("うまくいけば楽曲情報が表示され、「PLAY」で実際に遊ぶことができるようになります")]),_c('li',[_vm._v("同時に専用URLが生成されます。アクセスすると上記の音源・譜面を読み込んだ状態までセットアップを行います")])]),_c('div',{staticClass:"t-moon--dark"},[_vm._v("※試験的な機能です。Dropboxの機嫌次第でいきなり使えなくなるかも知れません")])])}]
var SharePlayer_esExports = { render: SharePlayer_render, staticRenderFns: SharePlayer_staticRenderFns }
/* harmony default export */ var components_SharePlayer = (SharePlayer_esExports);
// CONCATENATED MODULE: ./src/components/SharePlayer.vue
function SharePlayer_injectStyle (ssrContext) {
  __webpack_require__("JVnm")
}
var SharePlayer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SharePlayer___vue_template_functional__ = false
/* styles */
var SharePlayer___vue_styles__ = SharePlayer_injectStyle
/* scopeId */
var SharePlayer___vue_scopeId__ = "data-v-59f6e97a"
/* moduleIdentifier (server only) */
var SharePlayer___vue_module_identifier__ = null
var SharePlayer_Component = SharePlayer_normalizeComponent(
  SharePlayer,
  components_SharePlayer,
  SharePlayer___vue_template_functional__,
  SharePlayer___vue_styles__,
  SharePlayer___vue_scopeId__,
  SharePlayer___vue_module_identifier__
)

/* harmony default export */ var src_components_SharePlayer = (SharePlayer_Component.exports);

// EXTERNAL MODULE: ./node_modules/promise-polyfill/src/polyfill.js
var polyfill = __webpack_require__("bGr6");

// CONCATENATED MODULE: ./src/router/index.js








vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    label: 'HOME', // displayed as Link Label (if falsy, it won't be displayed)
    component: Home_Home
  }, {
    path: '/extra/share-player',
    name: 'SharePlayer',
    label: 'SHARE PLAYER',
    component: src_components_SharePlayer
  },

  // 確認用
  {
    path: '/test/hoge',
    name: 'Test',
    component: src_components_HelloWorld
  }]
}));
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugins/SimulatorModal/Component.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var SimulatorModal_Component = ({
  name: 'simulatorModal',
  props: {
    padding: { type: Number, default: 0 },
    zIndex: { type: Number, default: 10 },
    overlayAlpha: { type: Number, default: 0.9 }
  },
  data: function data() {
    return {
      isRunningSim: false
    };
  },

  computed: {
    wrapperStyleObject: function wrapperStyleObject() {
      return {
        "z-index": this.zIndex
      };
    },
    wrapperClassObject: function wrapperClassObject() {
      return {
        'wrapper': true,
        // v-ifはコンポーネント自体消えてしまうので使えない
        'hide': !this.isRunningSim
      };
    },
    overlayStyleObject: function overlayStyleObject() {
      return {
        'backgroundColor': 'rgba(0, 0, 0, ' + this.overlayAlpha + ')'
      };
    },
    contentStyleObject: function contentStyleObject() {
      return {
        'top': this.padding + "px",
        'left': this.padding + "px",
        'bottom': this.padding + "px",
        'right': this.padding + "px"
      };
    }
  },

  methods: {
    onClickCloseButton: function onClickCloseButton(e) {
      e.preventDefault();
      e.stopPropagation();
      SimulatorModal.event.$emit('close');
    },
    onRunSim: function onRunSim(music, project) {
      var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.isRunningSim) return;

      params.parent = this.$refs.content;
      params.musicSrc = music;
      params.musicScore = project, params.appMode = 'game';

      pxb.GameManager.bootApp(params);
      this.isRunningSim = true;
    },
    onCloseSim: function onCloseSim() {
      pxb.GameManager.idleApp();
      this.isRunningSim = false;
    }
  },

  beforeMount: function beforeMount() {
    SimulatorModal.event.$on('run', this.onRunSim.bind(this));
    SimulatorModal.event.$on('close', this.onCloseSim.bind(this));
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31aca30c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/SimulatorModal/Component.vue
var Component_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.wrapperClassObject,style:(_vm.wrapperStyleObject)},[_c('div',{staticClass:"overlay",style:(_vm.overlayStyleObject)}),_vm._v(" "),_c('div',{ref:"content",staticClass:"content",style:(_vm.contentStyleObject)}),_vm._v(" "),_c('div',{staticClass:"closeButton",on:{"click":_vm.onClickCloseButton}},[_c('i',{staticClass:"material-icons"},[_vm._v("close")])])])}
var Component_staticRenderFns = []
var Component_esExports = { render: Component_render, staticRenderFns: Component_staticRenderFns }
/* harmony default export */ var plugins_SimulatorModal_Component = (Component_esExports);
// CONCATENATED MODULE: ./src/plugins/SimulatorModal/Component.vue
function Component_injectStyle (ssrContext) {
  __webpack_require__("YkbC")
}
var Component_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var Component___vue_template_functional__ = false
/* styles */
var Component___vue_styles__ = Component_injectStyle
/* scopeId */
var Component___vue_scopeId__ = "data-v-31aca30c"
/* moduleIdentifier (server only) */
var Component___vue_module_identifier__ = null
var Component_Component = Component_normalizeComponent(
  SimulatorModal_Component,
  plugins_SimulatorModal_Component,
  Component___vue_template_functional__,
  Component___vue_styles__,
  Component___vue_scopeId__,
  Component___vue_module_identifier__
)

/* harmony default export */ var src_plugins_SimulatorModal_Component = (Component_Component.exports);

// CONCATENATED MODULE: ./src/plugins/SimulatorModal/index.js
/**
 * Simulator Modal
 * pxb-core Simulator modalをplugin APIから操作する
 *
 * @usage
 * <simulator-modal></simulator-modal>をtemplate内に記述した状態で
 * this.$pxbSim.run(music, project)
 * を実行
 *
 * @todo userOption設定用APIを用意する？
 */


// import ModalsContainer from './ModalsContainer.vue'

var defaultComponentName = 'simulator-modal';

var Plugin = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    /**
     * Makes sure that plugin can be insstalled only once
     */
    if (this.installed) return;

    this.installed = true;
    this.event = new Vue(); // EventBus
    this.componentName = options.componentName || defaultComponentName;

    /**
     * Plugin API
     */
    Vue.prototype.$pxbSim = {
      run: function run(music, project, params) {
        Plugin.event.$emit('run', music, project, params);
      },
      close: function close() {
        Plugin.event.$emit('close');
      }
      // setParam (params) {
      //   Plugin.event.$emit('set', music, project)
      // },

    };

    /**
     * Sets custom component name (if provided)
     */
    Vue.component(this.componentName, src_plugins_SimulatorModal_Component);

    //   /**
    //    * Registration of <ModalsContainer/> component
    //    */
    //   if (options.dynamic) {
    //     Vue.component('modals-container', ModalsContainer)
    //   }
  }
};

/* harmony default export */ var SimulatorModal = (Plugin);
// EXTERNAL MODULE: ./src/assets/styles/general.scss
var general = __webpack_require__("6k6n");
var general_default = /*#__PURE__*/__webpack_require__.n(general);

// CONCATENATED MODULE: ./src/main.js
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







vue_esm["a" /* default */].config.productionTip = false;
vue_esm["a" /* default */].use(SimulatorModal);

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  el: '#app',
  router: router,
  template: '<App/>',
  components: { App: src_App }
});

window.addEventListener("drop", function (e) {
  e = e || event;
  e.preventDefault();
}, false);
window.addEventListener("dragover", function (e) {
  e = e || event;
  e.preventDefault();
}, false);

/***/ }),

/***/ "Uxpk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "V7UB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YkbC":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZYS2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bXbE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cPLG":
/***/ (function(module, exports) {

module.exports = [{"id":0,"music":"./static/sample/grandfathers_clock/music.mp3","project":"./static/sample/grandfathers_clock/project.pxbp","jacket":"./static/sample/grandfathers_clock/jacket.png"},{"id":1,"music":"./static/sample/GGAM/music.mp3","project":"./static/sample/GGAM/project.pxbp"}]

/***/ }),

/***/ "gu2T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i311":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iQH9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.0bb238e.png";

/***/ }),

/***/ "ihbT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xWVD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zEgk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.db9fe41f19f853da4b53.js